import axios from 'axios';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { storeAction } from '../storeActions.constant';

export const champsCustomEmailState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
    };
};

export const champsCustomEmailMutations = {};

export const champsCustomEmailActions = {
    [storeAction.getAllCustomEmailGroups]: wrapAction(storeAction.getAllCustomEmailGroups, ({ state }, communityId) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/get-custom-email-groups-info/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data.message;
            });
    }),

    [storeAction.getMemberDetailsInfo]: wrapAction(storeAction.getMemberDetailsInfo, ({ state }, communityId) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/get-member-details-info/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data.message;
            });
    }),

    [storeAction.createCustomEmailGroup]: wrapAction(
        storeAction.createCustomEmailGroup,
        ({ state }, customEmailGroup) => {
            return axios({
                url: `${state.baseURL}communities/api/communities/create-custom-email-group`,
                headers: getBasicHeaders(),
                method: 'POST',
                data: customEmailGroup,
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err.response.data.message;
                });
        },
    ),

    [storeAction.deleteCustomEmailGroup]: wrapAction(
        storeAction.deleteCustomEmailGroup,
        async ({ state }, emailGroup) => {
            try {
                const response = await axios({
                    url: `${state.baseURL}communities/api/communities/delete-custom-email-group`,
                    headers: getBasicHeaders(),
                    method: 'PUT',
                    data: emailGroup,
                });
                return response;
            } catch (err) {
                console.log(err);
                throw err.response.data.message;
            }
        },
    ),

    [storeAction.editCustomEmailGroup]: wrapAction(storeAction.editCustomEmailGroup, ({ state }, customEmailGroup) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/update-custom-email-group`,
            headers: getBasicHeaders(),
            method: 'PUT',
            data: customEmailGroup,
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data.message;
            });
    }),
};

export const champsCustomEmailGetters = {};

export default {
    namespaced: true,
    state: {
        initialState: champsCustomEmailState(),
        ...champsCustomEmailState(),
    },
    mutations: { ...champsCustomEmailMutations },
    actions: { ...champsCustomEmailActions },
    getters: { ...champsCustomEmailGetters },
};
